import type { FC, SVGAttributes } from "react";

import { IcAnalytics, IcHome, IcManageAccounts } from "@/shared/assests/svg";

import { AdminNavIconBriefcase, AdminNavIconInbox, AdminNavIconMessage, AdminNavIconUsers } from "./adminNavIcons";

const ROUTES = {
    DASHBOARD: () => "/admin",
    CONTENT: () => "/admin/articles",
    CLIENTS: () => "/admin/clients",
    STAFF: () => "/admin/staff",
    NEWS: () => "/admin/news",
    ARTICLES: () => "/admin/articles",
    PORTFOLIO: () => "/admin/portfolio",
    SECTION: () => "/admin/sections",
    AI: () => "/admin/ai",
    CHAT: () => "/admin/chat",
    APPLICATIONS: () => "/admin/applications",
    FEEDBACK: () => "/admin/feedback",
};

enum Belong {
    MOBILE_BOTTOM_NAVIGATION = "MOBILE_BOTTOM_NAVIGATION",
    MOBILE_MENU = "MOBILE_MENU",
    DESKTOP_SIDE_BAR_NAVIGATION = "DESKTOP_SIDE_BAR_NAVIGATION",
}

const ROUTING_MAP: {
    label: string;
    link: string;
    belong: { name: Belong; sortId: number }[];
    Icon?: FC<SVGAttributes<SVGElement>>;
}[] = [
    {
        label: "Дашборд",
        link: ROUTES.DASHBOARD(),
        belong: [
            { name: Belong.MOBILE_BOTTOM_NAVIGATION, sortId: 0 },
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 0 },
            { name: Belong.MOBILE_MENU, sortId: 0 },
        ],
        Icon: IcAnalytics,
    },
    {
        label: "Материалы",
        link: ROUTES.CONTENT(),
        belong: [
            { name: Belong.MOBILE_MENU, sortId: 1 },
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 1 },
            { name: Belong.MOBILE_BOTTOM_NAVIGATION, sortId: 2 },
        ],
        Icon: IcManageAccounts,
    },
    {
        label: "Клиенты",
        link: ROUTES.CLIENTS(),
        belong: [
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 2 },
            { name: Belong.MOBILE_MENU, sortId: 2 },
        ],
        Icon: AdminNavIconUsers,
    },
    {
        label: "Сотрудники",
        link: ROUTES.STAFF(),
        belong: [
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 3 },
            { name: Belong.MOBILE_MENU, sortId: 3 },
        ],
        Icon: AdminNavIconBriefcase,
    },
    {
        label: "Разделы",
        link: ROUTES.SECTION(),
        belong: [
            { name: Belong.MOBILE_BOTTOM_NAVIGATION, sortId: 4 },
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 4 },
            { name: Belong.MOBILE_MENU, sortId: 4 },
        ],
        Icon: IcHome,
    },
    {
        label: "Чаты и заявки",
        link: ROUTES.CHAT(),
        belong: [
            { name: Belong.DESKTOP_SIDE_BAR_NAVIGATION, sortId: 5 },
            { name: Belong.MOBILE_MENU, sortId: 5 },
        ],
        Icon: AdminNavIconMessage,
    },
];

export { Belong, ROUTES, ROUTING_MAP };
